module.exports = __webpack_public_path__ + "img/图像-42@2x.afd8aed6.webp";